const $labels = document.querySelectorAll('label');
$labels.forEach(($label) => {
    let $field;
    if ($label.htmlFor) {
        $field = document.getElementById($label.htmlFor);
    } else {
        $field = $label.querySelector('input,textarea,checkbox,select');
    }

    if ($field && ['INPUT', 'TEXTAREA', 'SELECT'].includes($field.tagName)) {
        if ($field.required) {
            $label.classList.add('-required');
        } else {
            $label.classList.add('-optional');
        }
    }
});
